<script setup>
import i18n, { setI18nLanguage } from "@/configs/i18n";
import { useAuthStore } from "@/stores/auth";
import Button from "primevue/button";
import { useRouter } from "vue-router";
import { usePrimeVue } from "primevue/config";
const router = useRouter();

const props = defineProps({
  auth: {
    type: Boolean,
    default: false,
  },
});

const lang = useAuthStore();
const langOptions = lang.localeOptions;
const primevue = usePrimeVue();

const selectLocale = (lang) => {
  setI18nLanguage(lang);
  primevue.config.locale = window.locales[lang] ?? window.locales.ky;
  router.go(0);
};
</script>

<template>
  <ul class="lang-switcher mr-2">
    <li v-for="(locale, __index) in langOptions.locales" :key="__index" class="mr-2">
      <template v-if="!props.auth">
        <Button
          text
          :class="locale === i18n.global.locale.value ? 'text-blue-500' : 'text-gray-600'"
          class="font-bold text-sm p-0 uppercase outline-0 shadow-0 border-0 bg-transparent"
          @click.prevent="selectLocale(locale)"
          >{{ locale }}</Button
        >
      </template>
      <template v-if="props.auth">
        <Button
          text
          :class="locale === i18n.global.locale.value ? 'text-white' : 'text-gray-500'"
          class="font-bold text-sm p-0 uppercase outline-0 shadow-0 border-0 bg-transparent"
          @click.prevent="selectLocale(locale)"
          >{{ locale }}</Button
        >
      </template>
    </li>
  </ul>
</template>
